<template>
    <div class="order">
        <div class="search">
            <Button class="select" @click="showPicker = true">
                <div class="select">
                    <span>{{orderStatus}}</span>
                    <span style="margin: 1vw 0 0 0.5vw; color: #d2d2d2">
                        <Icon name="arrow-down"/>
                    </span>
                </div>
            </Button>
            <div class="inputView">
                    <span style="margin-top: 1vw">
                        <Icon name="search" size="5vw"/>
                    </span>
                <input class="input" v-model="queryForm.key" type="text" placeholder="网点名称 / 设备ID">
            </div>
            <Button class="searchBtn" @click="onSearch">
                <span>搜索</span>
            </Button>
        </div>
        <List v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="getList">
            <OrderItem v-for="(item, index) in orderList" :orderInfo="item" :key="index" @closeOrder="showCloseOrder" />
        </List>
        <Popup v-model="showPicker" position="bottom">
            <Picker
                show-toolbar
                :columns="orderStatusList"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            />
        </Popup>
        <Popup v-model="showPopup" class='closeOrderPopup' closeable>
            <div class="popupView">
                <h2 class="popupTitle">结束订单</h2>
                <div class="">
                    <div class="popupItem van-hairline--bottom">
                        <span class="title">操作类型</span>
                        <input type="text" v-model="closeOrderForm.typeText" @click="showCloseOrderPopup = true" readonly placeholder="请选择类型"/>
                        <Icon name="arrow"/>
                    </div>
                    <div class="popupItem van-hairline--bottom" v-if="closeOrderForm.type === 'ASSIGN_MONEY'">
                        <span class="title">指定金额</span>
                        <input type="text" class="marign" v-model="closeOrderForm.money" placeholder="请输入金额"/>
                    </div>
                    <div class="popupItem van-hairline--bottom">
                        <span class="title">备注</span>
                        <input type="text" v-model="closeOrderForm.description" class="marign" placeholder="请输入备注"/>
                    </div>
                </div>
                <Button class="closeOrderBtn" @click="closeOrder">确定</Button>
            </div>
        </Popup>
        <!--结束订单类型选择弹窗-->
        <Popup v-model="showCloseOrderPopup" position="bottom">
            <Picker
                show-toolbar
                :columns="closeOrderTypeList"
                @confirm="onConfirmCloseType"
                @cancel="showCloseOrderPopup = false" />
        </Popup>
    </div>
</template>

<script>
    /*
    * 订单
    * */
    import OrderItem from './components/OrderItem'
    import {Icon, Button, List, Picker, Popup} from 'vant';
    import {getOrderList, closeOrderApi} from "../../../api/order";

    export default {
        name: "Order",
        components: {
            Icon,
            Button,
            List,
            Picker,
            Popup,
            OrderItem
        },
        data() {
            return {
                showCloseOrderPopup: false,
                showPopup: false,
                listLoading: false,
                finished: false,
                orderList: [],
                showPicker: false,
                orderStatus: '全部',
                queryForm: {
                    orderStatus: '',
                    key: '',
                    size: 10,
                    page: 1
                },
                closeOrderForm: {
                    description: '',
                    money: '',
                    type: 'DEPOSIT_NOW',
                    typeText: '扣除至当前时间的租金'
                },
                closeOrderTypeList: [
                    {
                        text: '扣除至当前时间的租金',
                        value: 'DEPOSIT_NOW'
                    }, {
                        text: '扣除押金',
                        value: 'DEPOSIT_ALL',
                    }, {
                        text: '扣除指定金额',
                        value: 'ASSIGN_MONEY'
                    }
                ],
                orderStatusList: [
                    {
                        text: '全部',
                        value: ''
                    }, {
                        text: '已完结',
                        value: 'DONE'
                    },
                    // {
                    //     text: '已购买',
                    //     value: 'BOUGHT'
                    // },
                    {
                        text: '进行中',
                        value: 'USING'
                    },
                    // {
                    //     text: '已逾期',
                    //     value: 'OVERTIME_AND_PAYMENT'
                    // }
                ]
            }
        },
        methods: {
            showCloseOrder(orderSn) {
                this.closeOrderForm = {
                    orderSn,
                    description: '',
                    money: '',
                    type: 'DEPOSIT_NOW',
                    typeText: '扣除至当前时间的租金'
                };
                this.showPopup = true;
            },
            // 关闭订单
            closeOrder() {
                if (this.closeOrderForm.type === 'ASSIGN_MONEY' && (this.closeOrderForm.money === '' || this.closeOrderForm.money === ' ')) {
                    return this.toast({
                        text: '请填写指定金额',
                        icon: 'warning'
                    })
                }
                closeOrderApi(this.closeOrderForm).then(res => {
                    console.log(res);
                    this.onSearch();
                })
            },
            onSearch() {
                this.queryForm.page = 1;
                this.orderList = [];
                this.getList();
            },
            onConfirm(obj) {
                this.queryForm.orderStatus = obj.value;
                this.orderStatus = obj.text;
                this.showPicker = false;
            },
            // 确认选择结束订单类型
            onConfirmCloseType(obj) {
                this.closeOrderForm.type = obj.value;
                this.closeOrderForm.typeText = obj.text;
                this.closeOrderForm.money = '';
                this.showCloseOrderPopup = false;
            },
            getList() {
                getOrderList(this.queryForm).then(res => {
                    this.orderList = [...this.orderList, ...res.records];
                    // 加载状态结束
                    this.listLoading = false;
                    if (res.records.length < 10) {
                        // 数据全部加载完成
                        this.finished = true;
                        return;
                    }
                    this.queryForm.page++;
                })
            }
        }
    }
</script>

<style lang='less' scoped>
    .order {
        min-height: 100vh;
        background-color: #f7f7f7;

        .search {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 16.3vw;
            padding: 0 3vw;

            .select {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 19vw;
                height: 8.5vw;
                border: none;
                background-color: #ffffff;
                border-radius: 4.3vw;
                font-size: 4vw;
                color: #43a2fe;
            }

            .inputView {
                overflow: hidden;
                display: flex;
                align-items: center;
                width: 54.1vw;
                height: 8.5vw;
                padding-left: 7.7vw;
                background-color: #ffffff;
                border-radius: 4.3vw;
                color: #c3c3c3;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;

                .input {
                    flex: 1;
                    display: block;
                    height: 100%;
                    line-height: 8.5vw;
                    margin-left: 2vw;
                    border: none;
                    font-size: 4vw;
                    color: #555;

                    &::placeholder {
                        color: #c3c3c3;
                    }
                }
            }

            .searchBtn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 18.4vw;
                height: 8.5vw;
                border: none;
                line-height: 8.5vw;
                background-color: #ffffff;
                border-radius: 4.3vw;
                font-size: 4vw;
                color: #43a2fe;
            }
        }

        .closeOrderPopup {
            border-radius: 2.67vw;

            .popupView {
                width: 77.73vw;
                padding: 0 5.5vw;

                .popupTitle {
                    line-height: 15vw;
                    text-align: center;
                    font-size: 4vw;
                    font-weight: bold;
                    color: #333333;
                }

                .popupItem {
                    display: flex;
                    align-items: center;
                    height: 10.8vw;
                    color: #d2d2d2;
                    font-size: 3.73vw;

                    .title {
                        color: #333333;
                    }

                    input {
                        flex: 1;
                        margin-right: 3.07vw;
                        outline: none;
                        border: none;
                        text-align: right;
                        color: #333;

                        &.marign {
                            margin-right: 6.3vw;
                        }

                        &::placeholder {
                            color: #c7c7c7;
                        }
                    }
                }

                .closeOrderBtn {
                    display: block;
                    width: 23.6vw;
                    height: 8vw;
                    border: none;
                    margin: 5.47vw auto 4.67vw;
                    line-height: 8vw;
                    background-color: #43a2fe;
                    border-radius: 1.6vw;
                    font-size: 3.2vw;
                    color: #ffffff;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/order/Index.vue